import apiProduct from '@/api/public/product-discussion';

const defaultState = () => ({
	productDiscussion: [],
	loadProductDiscussion: false,
	detailProductDiscussion: {},
	productDiscussionPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setProductDiscussion(state, data) {
		state.productDiscussion = [ ...data.data ]
		state.productDiscussionPagination = data.pagination;
	},
	setloadProductDiscussion(state, data) {
		state.loadProductDiscussion = data
	},
	setDetailProductDiscussion(state, data) {
		state.detailProductDiscussion = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearProductDiscussion(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getProductDiscussion({ commit }, params) {
		commit('setloadProductDiscussion', true);
		return new Promise((resolve) => {
			apiProduct.getProductDiscussion(params).then(({ data: { data } }) => {
				commit('setProductDiscussion', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductDiscussion', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProductDiscussion', false);
			});
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};